// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"Paragraph_paragraph__1xCzI","whiteColor":"Paragraph_whiteColor__w8Key"};